import { ENVIRONMENT } from '../../constants';
import getEnvVariable from '../environment';

const showFreeTrialInConsole = () => {
  return getEnvVariable(ENVIRONMENT.SHOW_FREE_TRIAL_IN_CONSOLE) === 'true';
};

export default showFreeTrialInConsole;
